<template>
  <div
    class="d-flex align-items-center justify-content-center position-relative w-100 px-12 text-center mt-5 mt-md-16 mb-4 mb-md-7 mb-lg-12"
    style="min-height: 48px;">
    <button
      class="button button--iconed position-absolute top-0 left-0"
      :class="buttonStyle"
      @click="moveBack()"
      v-waves>
      <svg-icon
        icon="arrow"
        size="md" />
    </button>
    <h1
      class="m-0"
      :class="headingStyle">
      {{ title }}
    </h1>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    title: {
      type: String,
      required: ''
    },

    backPage: {
      type: String,
      required: ''
    }
  },
  computed: {
    currentBreakpoint() {
      /// Returns current 'morphological' breakpoint value based on window width
      ///
      /// @example
      ///   'xs' | 'sm' | 'md' | 'lg' | 'xl'

      return this.$store.state.config.currentBreakpoint
    },

    isDesktop() {
      return this.currentBreakpoint == 'md' || this.currentBreakpoint == 'lg' || this.currentBreakpoint == 'xl'
    },

    isMobile() {
      return this.currentBreakpoint == 'xs' || this.currentBreakpoint == 'sm'
    },

    buttonStyle() {
      if (this.isDesktop) return 'button--outline'
      else return 'button--text'
    },

    headingStyle() {
      if (this.isDesktop) return 'h1'
      else return 'h4'
    },
  },
  methods: {
    moveBack() {
      this.$store.commit('config/SET_CURRENT_TRANSITION', this.isDesktop ? 'fade-in-left' : 'overlay-up-full')
      setTimeout(() => {
        this.$router.push({ name: this.backPage })
      }, 100)
    },
  }
}
</script>
